// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  /* Responsive Design */
  @media (max-width: 900px) {
    .lp-page-grid {
      grid-template-areas:
        "top"
        "middle"
        "left"
        "right";
      grid-template-columns: 1fr;
      grid-template-rows: 80px auto auto auto;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/PostPage/PPGridLayout.css"],"names":[],"mappings":"EAAE,sBAAsB;EACtB;IACE;MACE;;;;eAIS;MACT,0BAA0B;MAC1B,uCAAuC;IACzC;EACF","sourcesContent":["  /* Responsive Design */\n  @media (max-width: 900px) {\n    .lp-page-grid {\n      grid-template-areas:\n        \"top\"\n        \"middle\"\n        \"left\"\n        \"right\";\n      grid-template-columns: 1fr;\n      grid-template-rows: 80px auto auto auto;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
